module.exports = __webpack_public_path__ + "static/media/IMG_20200902_200201_306.dfb5c309.jpg";